import { render, staticRenderFns } from "./LedgerStatementReport.vue?vue&type=template&id=270d242e&"
import script from "./LedgerStatementReport.vue?vue&type=script&lang=js&"
export * from "./LedgerStatementReport.vue?vue&type=script&lang=js&"
import style0 from "./LedgerStatementReport.vue?vue&type=style&index=0&id=270d242e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports